import { vuetify } from '../libs/vuetify'

export default defineNuxtPlugin((nuxtApp) => {
  // @ts-ignore
  nuxtApp.vueApp.use(vuetify)
})
